import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'
import ReactSelect from "../../../components/Form/Select/Select"

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FormSubstancia = ({ fechaModal, substancia_id}) => {
  //valores iniciais do formulario
  const inicialForm = {
    substancia_id     : '',
    substancia        : '',
    lista             : '',
    listaSelect       : ''
  }

  const [form, onChange, setForm, onChangeSelect] = useForm(inicialForm)
  const [lista, setLista]                         = useState([])
  const [loading, setLoading]                     = useState(true)

  // Lista tipo lista select
  const listaListas = () => {
    let lista = []
    const url = rotas.lista
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if ((ret.success) && (ret.success == 'S')){
          lista = ret.lista
          for (let i = 0; i < lista.length; i++) {
            lista[i] = {"id":ret.lista[i].lista_id, "title":ret.lista[i].lista}
            // lista[i] = {"title":ret.lista[i].lista}
          }
          setLista(lista)
        }
      })
      return (lista)
    }catch(err){
    }
  }

  const editSubstancia = (substancia_id) => {
    const url = rotas.substancia+substancia_id
    const retorno = rest.get(url)
    retorno.then(ret => {
      if (ret.success) {
        ret.lista[0].listaSelect = {"id":ret.lista[0].lista, "title":ret.lista[0].lista}
        setForm(ret.lista[0])
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    listaListas()
  }, [])

  useEffect(() => {
    if (listaListas()) {
      if(substancia_id != ''){
        editSubstancia(substancia_id)
      }else{
        setForm(inicialForm)
        setLoading(false)
      }
    }
  },[])

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.substancia+'gravar.php'
        if(substancia_id !== ''){
          return rest.post(url, form)
            .then(ret => {
              editSubstancia(substancia_id)
              if (ret.success == 'S') {
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
            })
        }else{
          return rest.put(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editSubstancia(ret.retorno.insert_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
            })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <>
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md='2'>
                <FormGroup>
                  <Label for="substancia_id">Código</Label>
                  <Input
                    disabled
                    style     = {{background: '#F9F9F9'}}
                    name      = "substancia_id"
                    id        = "substancia_id"
                    value     = {form.substancia_id}
                    onChange  = {onChange('substancia')}
                  />
                </FormGroup>
              </Col>

              <Col md='7'>
                <FormGroup>
                  <Label for="substancia">Substância</Label>
                  <Input
                    required
                    name      = "substancia"
                    id        = "substancia"
                    value     = {form.substancia}
                    onChange  = {onChange('substancia')}
                  />
                </FormGroup>
              </Col>

              <Col md='3'>
                <FormGroup>
                  <ReactSelect
                    name          = "lista"
                    label         = "Lista"
                    placeholder   = "Selecione"
                    options       = {lista}
                    defaultValue  = {form.listaSelect}
                    onChange      = {onChangeSelect('listaSelect')}
                    onClick       = {form.lista = form.listaSelect.title}
                  >
                  </ReactSelect>
                </FormGroup>
              </Col>
            </Row>

            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
      </>
    )
  }

}

export default FormSubstancia
